<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
        <mat-checkbox
            class="checklist-leaf-node"
            color="primary"
            [checked]="listSelection.isSelected(node.item)"
            (change)="leafItemSelectionToggle(node)"
        >
            <ng-template
                *ngTemplateOutlet="nodeTemplateRef; context: node.item.element"
            ></ng-template>
        </mat-checkbox>
    </mat-tree-node>

    <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
        <mat-checkbox
            color="primary"
            [checked]="descendantsAllSelected(node)"
            [indeterminate]="descendantsPartiallySelected(node)"
            [disabled]="disableBranchSelection"
            (change)="itemSelectionToggle(node)"
        >
            <ng-template
                *ngTemplateOutlet="nodeTemplateRef; context: node.item.element"
            ></ng-template>
        </mat-checkbox>
    </mat-tree-node>
</mat-tree>
